// @flow

const REDACTED = '[redacted]';
const REDACTED_EMAIL = '[redacted_email]';
const REDACTED_PHONE = '[redacted_phone]';

const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
const PHONE_REGEX = /(?:\+?82[-.\s]?)?0(?:10|11|16|17|18|19|2|3[1-3]|4[1-4]|5[1-5]|6[1-4])[-.\s]?\d{3,4}[-.\s]?\d{4}/g;

const SENSITIVE_KEY_REGEX = /(email|phone|mobile|tel|contact|address|postcode|zip|business_?no|businessNo|bizNumber|tax_?registration_?id|taxRegistrationId)/i;

export const sanitizeTrackingText = (value: string): string => {
  return value
    .replace(EMAIL_REGEX, REDACTED_EMAIL)
    .replace(PHONE_REGEX, REDACTED_PHONE);
};

function sanitizeTrackingValue(value: any, key: string = ''): any {
  if (SENSITIVE_KEY_REGEX.test(key)) return REDACTED;
  if (typeof value === 'string') return sanitizeTrackingText(value);
  if (Array.isArray(value)) {
    return value.map(item => sanitizeTrackingValue(item));
  }
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((acc, nestedKey) => {
      acc[nestedKey] = sanitizeTrackingValue(value[nestedKey], nestedKey);
      return acc;
    }, {});
  }
  return value;
}

export function sanitizeTrackingProperties(properties: { [key: string]: any } = {}): Object {
  return Object.keys(properties).reduce((acc, key) => {
    acc[key] = sanitizeTrackingValue(properties[key], key);
    return acc;
  }, {});
}



// WEBPACK FOOTER //
// ./src/lib/tracking/privacy.js